import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import PropTypes from 'prop-types'
import React, { useState, useCallback } from 'react'

import { TabPanel } from 'components/common'

import { WORK_ORDER_TABS } from './settings'
import WorkOrderActivityTab from './tabs/WorkOrderActivityTab'
import WorkOrderContainersTab from './tabs/WorkOrderContainersTab'
import WorkOrderExceptionsTab from './tabs/WorkOrderExceptionsTab'
import WorkOrderRoutingTab from './tabs/WorkOrderRoutingTab'

const { ROUTING, CONTAINERS, EXCEPTIONS, ACTIVITY } = WORK_ORDER_TABS

const WorkOrderTabs = ({ workOrder = {}, accountId = '' }) => {
  const [selectedTab, setSelectedTab] = useState(ROUTING)

  const { workOrderId, configuredServiceId, exceptions = [], configuredServiceEventId = '', configuredServiceEventType = '' } = workOrder

  const handleTabChange = useCallback((event, newValue) => {
    setSelectedTab(newValue)
  }, [])

  return (
    <>
      <Box pl={2}>
        <Tabs sx={{ button: { textTransform: 'capitalize' } }} value={selectedTab} onChange={handleTabChange}>
          <Tab label={ROUTING} value={ROUTING} />
          <Tab label={CONTAINERS} value={CONTAINERS} />
          <Tab label={EXCEPTIONS} value={EXCEPTIONS} />
          <Tab label={ACTIVITY} value={ACTIVITY} />
        </Tabs>
      </Box>

      <TabPanel reRender index={ROUTING} value={selectedTab}>
        <WorkOrderRoutingTab accountId={accountId} workOrder={workOrder} />
      </TabPanel>
      <TabPanel reRender index={CONTAINERS} value={selectedTab}>
        <WorkOrderContainersTab configuredServiceId={configuredServiceId} workOrderId={workOrderId} />
      </TabPanel>
      <TabPanel reRender index={EXCEPTIONS} value={selectedTab}>
        <WorkOrderExceptionsTab accountId={accountId} exceptions={exceptions} workOrderId={workOrderId} />
      </TabPanel>
      <TabPanel reRender index={ACTIVITY} value={selectedTab}>
        <WorkOrderActivityTab
          configuredServiceEventId={configuredServiceEventId}
          configuredServiceEventType={configuredServiceEventType}
          configuredServiceId={configuredServiceId}
          workOrderId={workOrderId}
        />
      </TabPanel>
    </>
  )
}

WorkOrderTabs.propTypes = {
  workOrder: PropTypes.object,
  accountId: PropTypes.string,
}

export default WorkOrderTabs
